export enum ActionType {
    Activated = 'Activated',
    Inactivated = 'Inactivated',
    Originated = 'Originated',
    Approved = 'Approved',
    Rejected = 'Rejected'
}
